// extracted by mini-css-extract-plugin
export var btn = "Button-module--btn--b4e49";
export var btnIcon = "Button-module--btnIcon--63021";
export var disabled = "Button-module--disabled--a21a0";
export var empty = "Button-module--empty--5fdb6";
export var full = "Button-module--full--fe8a8";
export var fullImage = "Button-module--fullImage--41685";
export var hasLabel = "Button-module--hasLabel--87242";
export var iconLeft = "Button-module--iconLeft--f0075";
export var iconRight = "Button-module--iconRight--4e68c";
export var lg = "Button-module--lg--47285";
export var md = "Button-module--md--eed22";
export var outline = "Button-module--outline--20dfa";
export var primary = "Button-module--primary--e5279";
export var sm = "Button-module--sm--9aadc";
export var xl = "Button-module--xl--18cc2";